import Link from 'Components/shared/Link/Link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { PATHS } from 'Libraries/routes.library';
import { basicChannel } from 'src/channels/basic.channel';

const notLinkList: Array<PATHS> = [PATHS.SPORTS, PATHS.ACCOUNT_SOFQ, PATHS.ACCOUNT_VERIFY];

export interface ILinkHandler {
  children?: React.ReactNode;
  href: string;
  className?: string;
  shallow?: boolean;
}
enum EelementType {
  LINK = 'LINK',
  A = 'A',
}
export const LinkHandler = ({
  href,
  children,
  className = '',
  shallow = false,
}: React.PropsWithChildren<ILinkHandler>) => {
  const router = useRouter();
  const locale = router?.locale === 'en' ? '' : `/${router?.locale}`;

  const [linkElement, setLinkElement] = useState(EelementType.LINK);

  useEffect(() => {
    if (notLinkList.includes(router.pathname as PATHS)) {
      setLinkElement(EelementType.A);
    }
  }, [router.pathname]);

  const clearOverlays = () => {
    basicChannel.clear();
  };

  return (
    <>
      {linkElement == EelementType.LINK && (
        <Link href={href} shallow={shallow} className={className} onClick={clearOverlays}>
          {children}
        </Link>
      )}
      {linkElement == EelementType.A && (
        <a href={`${locale}${href}`} className={className} onClick={clearOverlays}>
          {children}
        </a>
      )}
    </>
  );
};
